import { render, staticRenderFns } from "./RegisterFeatureDescription.vue?vue&type=template&id=5c183de1&"
import script from "./RegisterFeatureDescription.vue?vue&type=script&lang=js&"
export * from "./RegisterFeatureDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports